import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';
import {Component, OnInit} from '@angular/core';
import {User, UsersService} from '@hassel-it/angular-common';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ShipmentsService} from '../services/shipments.service';
import {ShipmentRoutesService} from '../services/shipment-routes.service';
import {ActivatedRoute} from "@angular/router";

declare let NProgress: any;

@Component({
    providers: [ShipmentsService, ShipmentRoutesService],
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

    public user: User;

    constructor(
        public activatedRoute: ActivatedRoute,
        public usersService: UsersService,
        public ngbModal: NgbModal) {
    }

    ngOnInit() {
        this.usersService.getCurrentUser().then(user => {
            this.user = user;

        });
    }
}
